import * as React from "react";
import * as __intl__ from "@frameio/i18n";
export type Text = {
    rate: (planPeriod: string, cost: number) => string;
};
export type Deps = {};
export default {
    DEFINE(_messages: Text, {}: Deps = {}): void {
        return Object.defineProperties(this, {
            /** Formatted plan rate string by billing period */
            rate: {
                get() {
                    return __intl__.withIntl(this[__intl__.BOUND_INTL] ?? __intl__.getIntl(), () => (planPeriod: string, cost: number): string => __intl__.intl().formatMessage({ id: "getPlanRate.rate?c=35npfg02mu1ua", defaultMessage: "{planPeriod, select, MONTHLY {${cost, number}/mo} YEARLY {${cost, number}/yr} SEMIANNUALLY {${cost, number}/6mo} other {}}" }, { planPeriod: planPeriod, cost: cost }));
                },
                enumerable: true,
                configurable: true
            }
        });
    }
} as Text & {
    DEFINE(messages: Text, deps?: Deps): void;
};
